import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import InvoiceHTMLRenderer from './InvoiceHTMLRenderer';

const textColor = '#2A4494';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column'
  },
  headerContainer: {
    flexDirection: 'column',
    marginTop: 20
  },
  label: {
    paddingBottom: 3,
    fontSize: 12,
    color: textColor,
    fontStyle: 'bold'
  },
  desc: {
    wordBreak: 'break-word',
    fontSize: 10,
    maxWidth: '100%',
    textAlign: 'justify'
  }
});

const breakLongWords = (text, max = 92) => text.replace(new RegExp(`(\\S{${max}})`, 'g'), '$1 ');

const InvoiceNotes = ({ invoice }) => (
  <View style={styles.container}>
    {invoice.notes && (
      <View style={styles.headerContainer}>
        <Text style={styles.label}>Notas</Text>
        <Text style={styles.desc}>{breakLongWords(invoice.notes)}</Text>
      </View>
    )}

    {invoice.terms_and_conditions && invoice.terms_and_conditions.length && (
      <View style={styles.headerContainer}>
        <Text style={styles.label}>Términos y condiciones</Text>
        <Text style={styles.desc}>{invoice.terms_and_conditions}</Text>
      </View>
    )}

    {invoice.terms_and_condition && invoice.terms_and_condition.terms_conditions_content?.length && (
      <View style={styles.headerContainer}>
        <Text style={styles.label}>Términos y condiciones</Text>
        <InvoiceHTMLRenderer htmlText={invoice.terms_and_condition.terms_conditions_content} />
      </View>
    )}
  </View>
);

export default InvoiceNotes;
